import {
  CreatePriceComponentRequest,
  PriceComponentAPI,
  PriceComponentModelV2,
  PriceComponentV2RequestModel,
  apiCreatePriceComponent,
  apiCreatePriceComponentV2,
  apiGetPriceComponentByPrice
} from '../../api/Argentia/endpoints/priceComponents'
import {
  createSuccessServiceResponse,
  createErrorServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'

/**
 * OBSOLETE -- use PriceComponentModelV2() instead
 * @param request
 * @returns
 */
export const createPriceComponent = async (
  request: CreatePriceComponentRequest
): Promise<ServiceResponse<PriceComponentAPI | undefined>> => {
  return await apiCreatePriceComponent(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

/**
 * Creates PriceComponent and Price using API version 2 instead
 * @param request - PriceComponentModelV2 to be created
 * @returns id of the created PriceComponent and Price
 */
export const createPriceComponentV2 = async (
  request: PriceComponentV2RequestModel
): Promise<ServiceResponse<PriceComponentAPI | undefined>> => {
  return await apiCreatePriceComponentV2(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const getPriceComponentByPrice = async (
  priceID: number
): Promise<ServiceResponse<PriceComponentAPI | undefined>> => {
  return await apiGetPriceComponentByPrice({ priceID })
    .then(response => {
      return createSuccessServiceResponse(response && response.length > 0 ? response[0] : undefined)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
